import { FlowFormSetSearchScope, FlowGetFormSetBlockSchema, FlowGetFormSetType } from 'flow-schema';

import { type api } from 'common';

import { GetFormSetFormFields } from './FormFields';
import { getFormSetBlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getFormSetNodeConfig: BlockConfigProps<api.FlowDefinition.GetFormSetBlock['config']> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'getFormSet',
    defaultConfig: {
      type: FlowGetFormSetType.AutomaticallyApplied,
      searchScope: FlowFormSetSearchScope.CurrentPractice,
    },
    configFields: {
      schema: FlowGetFormSetBlockSchema.shape.config,
      FormFields: GetFormSetFormFields,
    },
    documentationMarkdown: getFormSetBlockDocumentationMarkdown,
  };
